import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementService`;


const ApiAmusementService = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getServiceTemplatesAndEvents(params) {
    const url = `${baseServiceUrl}/getServiceTemplatesAndEvents`;
    return ServiceApi.get(url, { params });
  },
  getAllAmusementServices: (params) => {
    const url = `${baseServiceUrl}/getAllAmusementServices`;
    return ServiceApi.get(url, params);
  },
  getAllAmusementGroups: (params) => {
    const url = `${baseServiceUrl}/getAllAmusementGroups`;
    return ServiceApi.get(url, { params });
  },
  getAllServicesByGroupId: (params) => {
    const url = `${baseServiceUrl}/getAllServicesByGroupId`;
    return ServiceApi.get(url, { params });
  },
  getAmusementReserveItem: (params) => {
    const url = `${baseServiceUrl}/getAmusementReserveItem`;
    return ServiceApi.get(url, { params });
  },
  getAmusementReserveItemGroup: (params) => {
    const url = `${baseServiceUrl}/getAmusementReserveItemGroup`;
    return ServiceApi.get(url, { params });
  },
  // getReserveDetails: (params) => {
  //   const url = `${baseServiceUrl}/getReserveDetails`;
  //   return ServiceApi.get(url, { params });
  // },

};

export default ApiAmusementService;


